/** @format */

import React, { useState, useRef, useEffect, useCallback } from "react";

const SingleSelectDropdown = ({ options, selected = "", onChange, placeholder = "Select...", required, name }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = useCallback((e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  const handleSelect = (val) => {
    setOpen(false);
    onChange(val);
  };

  const displayText = selected || placeholder;

  return (
    <div ref={ref} style={{ position: "relative" }}>
      {required && (
        <input
          type="text"
          name={name}
          value={selected}
          required
          onChange={() => {}}
          style={{ position: "absolute", opacity: 0, height: 0, width: 0, pointerEvents: "none" }}
          tabIndex={-1}
        />
      )}
      <button
        type="button"
        className="form-control text-left d-flex justify-content-between align-items-center"
        onClick={() => setOpen((prev) => !prev)}
        style={{ cursor: "pointer", minHeight: "38px" }}
      >
        <span style={{ color: selected ? "inherit" : "#999" }}>{displayText}</span>
        <i className="fal fa-chevron-down ml-2" style={{ fontSize: "0.75rem", flexShrink: 0 }}></i>
      </button>
      {open && (
        <div
          className="border bg-white shadow-sm"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1050,
            maxHeight: "250px",
            overflowY: "auto",
            borderRadius: "4px",
          }}
        >
          {options.map((opt, i) => (
            <button
              key={i}
              type="button"
              className={`dropdown-item py-2${selected === opt ? " active" : ""}`}
              onClick={() => handleSelect(opt)}
              style={{ cursor: "pointer", fontSize: "0.9rem", whiteSpace: "normal", wordWrap: "break-word" }}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SingleSelectDropdown;
